import { useRef } from 'react'
import type { StoreApi } from 'zustand/vanilla'

type StoreCreator<T, Q> = (initState?: T) => StoreApi<Q>

export const useContextStore = <T, Q>(
	createStore: StoreCreator<T, Q>,
	initState?: T
) => {
	const storeRef = useRef<StoreApi<Q> | null>(null)
	if (storeRef.current === null) {
		storeRef.current = createStore(initState)
	}

	return storeRef.current
}
